var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transaction-filter',{attrs:{"action":_vm.filterAction,"query":_vm.query,"form_id":"user-filter"}}),_c('transactions-statistics',{on:{"updateReport":function($event){return _vm.updateReport($event)}}}),(_vm.user)?_c('kt-datatable',_vm._b({ref:"datatable"},'kt-datatable',_vm.datatableProps,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }